<div class="container-fluid " id="element-to-export">
  <div class="row mb-2 pt-2" style="    display: flex;

  align-items: center;">

    <div class="col-md-7 px-0 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px;
  color: #262756;font-weight: bold">véhicules</p>

      <small class="text-uppercase" style="font-size:15px ;display: flex;color: #707070;
      align-items: center;"><span  class="cursor-pointer"  [routerLink]="['/user/vehicule']" routerLinkActive="router-link-active" >liste des véhicules</span><mat-icon>navigate_next</mat-icon>Détails véhicule ({{veh}} {{plaque}}) </small>


    </div>
     
 

  </div>
  <ngx-spinner bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547" type="ball-clip-rotate-multiple"
    [fullScreen]="true">
    <p style="color: white"> </p>
  </ngx-spinner>

  <div class="row">
    <div class="col-xl-1"></div>
    <div class=" col-xl-3 mb-2 col-md-6 w-100 px-0">


      <div class="col-12 col-md-12 w-100 ">
          <div class="container-fluid ">
              <div class="row rowposition px-0 pt-0" style="    max-height: 182px;">




                  <div class="col-6">

                      <div class="score-item">
                          <img class="safety_Score" alt="" placement="bottom" ngbTooltip="Score de sécurité"
                              src="assets/newImages/security-svg.svg" />
                          <div class="chart-infos">
                              <div class="d-flex justify-content-center mt-1">
                                  <h4>{{scoreS}}%</h4>
                                  <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_sec == 1 )">
                                      arrow_upward </mat-icon>

                                  <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_sec == 0 )">
                                      arrow_forward</mat-icon>

                                  <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_sec == -1 )">
                                      arrow_downward </mat-icon>
                              </div>
                          </div>
                          <div class="chart-unit">
                              <h5>{{distanceEntreMan}}Km <span>Entre les risques</span></h5>
                          </div>
                      </div>

                  </div>

                  <div class="col-6">
                      <div class="score-item">
                          <img class="safety_score" alt="" placement="bottom" ngbTooltip="Score d'économie"
                              src="assets/newImages/tree.svg" />
                          <div class="chart-infos">
                              <div class="d-flex justify-content-center mt-1">
                                  <h4>{{scoreEc}}%</h4>
                                  <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_eco == 1 )">
                                      arrow_upward </mat-icon>

                                  <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_eco == 0 )">
                                      arrow_forward</mat-icon>

                                  <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_eco == -1 )">
                                      arrow_downward </mat-icon>
                              </div>
                          </div>
                          <div class="chart-unit">
                              <h5>{{tmpinactivite}}% <span>inactivité moyenne</span></h5>
                          </div>
                      </div>
                  </div>




              </div>


          </div>

      </div>

  </div>
  <div class="col-xl-8 row" style="margin-top: 3%;">
    <div class="col-2"></div>
    <div class="col-2">
      <mat-form-field appearance="fill">
        <mat-label>Filtrer par</mat-label>
        <mat-select>
            <mat-option selected (click)="getFilterChoise(1)" [value]="'1 Jour'">
                1 Jour
            </mat-option>
            <mat-option selected (click)="getFilterChoise(7)" [value]="'7 Jours'">
              7 Jours
          </mat-option>
          <mat-option  selected (click)="getFilterChoise(14)" [value]="'2 Semaines'">
            2 Semaines
        </mat-option>
        <mat-option selected (click)="getFilterChoise(30)" [value]="'1 Mois'">
          1 Mois
      </mat-option>
        </mat-select>
       
    </mat-form-field>
    </div>
    <div class="col-4 w-100 pl-0 ">

      <mat-form-field appearance="fill">
        <mat-label>Filtrer par date Début-Fin</mat-label>
        <mat-date-range-input [formGroup]="rangeForm" [min]="minDate" [max]="maxDate" [rangePicker]="picker2">
          <input formControlName="start" autocomplete="off" readonly matStartDate placeholder="Date Début">
          <input formControlName="end" autocomplete="off" readonly matEndDate placeholder="End date"
            (dateChange)="addNewDate(rangeForm )">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker2" placement="left" ngbTooltip="Filtrer par date Début-Fin">
        </mat-datepicker-toggle>
        <mat-date-range-picker maxRange=29 #picker2></mat-date-range-picker>
      </mat-form-field>



    </div>
    <div class="col-4  w-100 ">


      <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 20px;" (click)="hiddencontenu()">
        <mat-label>Sélectionner un véhicule</mat-label>
        <!--(keyup)="applyFilterer($event)"-->
        <input id="getdt" name="getdt" type="text" aria-label="Number" matInput (keyup)="applyFilter1($event)"
          (click)="hiddencontenu2()" value="{{ itemSelect2 }}" [ngModel]="itemSelect2" [formControl]="myControl"
          [matAutocomplete]="auto" />



        <button mat-button matSuffix mat-icon-button>
          <mat-icon placement="bottom" ngbTooltip="Actualiser la liste des véhicules" (click)="refrech()">refresh
          </mat-icon>

        </button>
        <button mat-button matSuffix mat-icon-button (click)="hiddencontenu()">
          <mat-icon placement="bottom" ngbTooltip="Lister les véhicules">filter_list</mat-icon>

        </button>


        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">

          <ngx-spinner *ngIf="spinnerActive != false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
            type="ball-clip-rotate-multiple" [fullScreen]="false">
            <p style="color: white"> </p>
          </ngx-spinner>
          <table class="table-hover" mat-table [dataSource]="dataSourcet">
            <!-- Position Column -->
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>Contact.</th>
              <td mat-cell *matCellDef="let elementt" [ngClass]="{
                    highlight: selectedRowIndex2 == elementt.id
                  }" (click)="getItemDetails2(elementt)">
                <strong> plaque: {{ elementt.plate }} </strong> <br />
                Nom véhicule: {{ elementt.name}} <br />

                Id véhicule: {{ elementt.id }}
              </td>
            </ng-container>

            <tr class="d-none" mat-header-row *matHeaderRowDef="displayedColumnst"></tr>
            <tr mat-row *matRowDef="let elementt; columns: displayedColumnst"></tr>
          </table>

          <mat-paginator #secondPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

          <mat-option class="d-none"> </mat-option>
        </mat-autocomplete>
      </mat-form-field>


    </div>
  </div>

 <div class="col-12">
   <hr>
 </div>

  <div class="col-lg-3 col-xl-3 col-md-6 pr-0 py-2" style="  border-radius: 6px">
    <div class="mr-2"
        style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
        <ul class="list-group ">
            <li class="list-group-item active" style="color: #ffffff">
                <img src="assets/newImages/vehicule.svg" /> Véhicule
            </li>
        </ul>

        <div  class="col-12 col-md-3 w-100 my-1  p-2 "
            style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

            <div class="row px-2 ">
                <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                    <thead class="d-none">
                        <tr class="d-none">
                            <th scope="col">Last</th>   
                            <th scope="col">Handle</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Nom</b></td>
                            <td style="max-width:40px; word-wrap:break-word;">{{veh}}</td>
                        </tr>
                        <tr>
                            <td><b>Plaque</b></td>
                            <td style=" word-wrap:break-word;">{{plaque}}</td>
                        </tr>
                        <!-- <tr>
                            <td> <b>Groupes</b></td>
                            <td style="max-width:40px; word-wrap:break-word;">@twitter</td>
                        </tr> -->
                        <tr>
                            <td><b>Marque</b> </td>
                            <td style="max-width:20px; word-wrap:break-word;">{{marque}}</td>
                        </tr>



                    </tbody>
                </table>

            </div>
        </div>


    </div>



</div>
<div class="col-lg-3 col-xl-3 col-md-6  p-0 py-2" style="  border-radius: 6px">
    <div class="mr-2"
        style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
        <ul class="list-group ">
            <li class="list-group-item active" style="color: #ffffff">
                <img src="assets/newImages/distance.svg" /> Distance
            </li>
        </ul>
        <div 
            class="col-12 col-md-3 w-100 my-1  px-2 py-0 "
            style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
            <div class="row px-2 ">

                <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                    <thead class="d-none">
                        <tr class="d-none">
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Total</b></td>  
                            <td style="max-width:20px; word-wrap:break-word;">
                                {{total_dist}} Km</td>
                        </tr>
                        <tr>
                            <td><b>Moyenne / trajet </b></td>
                            <td style="max-width:20px; word-wrap:break-word;">
                                {{moy_trajet_dist}} Km </td>
                        </tr>
                        <tr>
                            <td><b>Moyenne / jour </b></td>
                            <td style="max-width:20px; word-wrap:break-word;">
                                {{moy_jour_dist}} Km</td>
                        </tr>




                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div>
<div class="col-lg-3 col-xl-3 col-md-6 px-xl-0 px-lg-0 pr-0 py-2" style="  border-radius: 6px">
    <div class="mr-2"
        style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
        <ul class="list-group ">
            <li class="list-group-item active" style="color: #ffffff">
                <img src="assets/newImages/duree.svg" /> Durée
            </li>
        </ul>

        <div 
            class="col-12 col-md-3 w-100 my-1  px-2 py-0 "
            style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
            <div class="row px-2 ">
                <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                    <thead class="d-none">
                        <tr class="d-none">
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                        </tr>
                    </thead>
                    <tbody>  
                        <tr>
                            <td><b>Total</b></td>
                            <td style="max-width:40px; word-wrap:break-word;">
                              {{total_duree | formatTime}} </td>
                        </tr>
                        <tr>
                            <td><b>Moyenne / trajet </b></td>
                            <td style=" word-wrap:break-word;">
                              {{moy_trajet_duree | formatTime}} </td>
                        </tr>
                        <tr>
                            <td><b>Moyenne / jour </b></td>
                            <td style="max-width:40px; word-wrap:break-word;">
                              {{moy_duree_jour | formatTime}} </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="col-lg-3 col-xl-3 col-md-6  p-0 py-2" style="  border-radius: 6px">
    <div class="mr-2"
        style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
        <ul class="list-group " style="list-style-type: none;">
            <li class="list-group-item active" style="color: #ffffff">
                <img weight="25px" height="25px" src="assets/newImages/activite.svg" /> Activité
            </li>
        </ul>
        <div  
            class="col-12 col-md-3 w-100 my-1  px-2 py-0 "
            style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

            <div class="row px-2 ">
                <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                    <thead class="d-none">
                        <tr class="d-none">
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>   
                            <td><b>Nbr trajets </b></td>
                            <td style="max-width:40px; word-wrap:break-word;">{{nbr_trajets}}</td>
                        </tr>
                        <tr>
                            <td><b>Nbr événement</b></td>
                            <td style=" word-wrap:break-word;">{{nbr_events}}</td>
                        </tr>
                        <tr>
                            <td><b>Jours actifs </b></td>
                            <td style="max-width:40px; word-wrap:break-word;">{{jrs_actives}}</td>
                        </tr>
                        <tr>
                            <td><b>Vitesse moyenne</b></td>
                            <td style="max-width:20px; word-wrap:break-word;">{{vitesse_moy}} Km/h</td>
                        </tr>




                    </tbody>
                </table>

            </div>
        </div>

    </div>
</div>
   <!--  <div class="col-lg-3 col-xl-3 col-md-12 w-100 mb-2 ">

      <div class="row">

        <div class="col-lg-12 col-xl-12 col-md-6 w-100 mb-2 pl-0">
          <div class="p-3 mb-2 d-flex zoomdetails"
            style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
            <img style="height: 36px;" src="../../../../assets/core-img/safety_score.png" alt="" placement="bottom"
              ngbTooltip="Score de sécurité">
            <p class=" px-3 mt-2 scoreFontFamily">{{scoreS}}% </p>
            <div class="vr"></div>
            <mat-icon class="mt-2" style="color: #4ca846b5;" *ngIf="(sc_tnd_sec == 1 )"> arrow_upward </mat-icon>

            <mat-icon class="mt-2" style="color: #237dbdb0;" *ngIf="(sc_tnd_sec == 0 )"> arrow_forward</mat-icon>

            <mat-icon class="mt-2" style="color: #e15b6b;" *ngIf="(sc_tnd_sec == -1 )"> arrow_downward </mat-icon>
            <div class="vr"></div>
            <p class=" px-3 mt-2 scoreFontFamily">{{distanceEntreMan}}Km </p>
            <p class="scoreFontFamilyCommentaire">entre les risques</p>
          </div>

        </div>
        <div class="col-lg-12 col-xl-12 col-md-6 w-100 mb-2 pl-0">
          <div class="p-3 mb-2 d-flex zoomdetails"
            style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
            <img style="height: 36px;" class="safety_score" src="../../../../assets/core-img/eco_score.png" alt=""
              placement="bottom" ngbTooltip="Score d'économie">
            <p class=" px-3 mt-2 scoreFontFamily">{{scoreEc}}% </p>
            <div class="vr"></div>
            <mat-icon class="mt-2" style="color: #4ca846b5;" *ngIf="(sc_tnd_eco == 1 )"> arrow_upward </mat-icon>

            <mat-icon class="mt-2" style="color: #237dbdb0;" *ngIf="(sc_tnd_eco == 0 )"> arrow_forward</mat-icon>

            <mat-icon class="mt-2" style="color: #e15b6b;" *ngIf="(sc_tnd_eco == -1 )"> arrow_downward </mat-icon>
            <div class="vr"></div>
            <p class=" px-3 mt-2 scoreFontFamily">{{tmpinactivite}}% </p>
            <p class="scoreFontFamilyCommentaire">inactivité moyenne</p>
          </div>

        </div>
        <div class="col-lg-12 col-xl-12 col-md-12 w-100 mb-2 pl-0">
          <div class="p-3 mb-2"
            style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
            <mat-chip-list>
              <mat-chip style="background: #1f1f20; color: #ffffff" selected (click)="getFilterChoise(1)">1 jour
                {{urltest}}
              </mat-chip>
              <mat-chip selected style="background: #fdd512; color: #ffffff" (click)="getFilterChoise(7)">7
                jours</mat-chip>
              <mat-chip selected style="background: #237dbd; color: #ffffff" (click)="getFilterChoise(14)">2 semaines
              </mat-chip>
              <mat-chip color="primary" selected (click)="getFilterChoise(30)">1 mois</mat-chip>
            </mat-chip-list>
          </div>



          <div class="divDetails">

            <ul class="list-group " style="list-style-type: none;">
              <li class="list-group-item active" style="color: #ffffff">

                <img src="https://img.icons8.com/fluent/25/000000/details-popup.png" /> Détails


              </li>
            </ul>
            <div class="row  pt-2 m-0" style="background-color:#FFFFFF">
              <div class="col-12 col-md-12 p-0 " style="  border-radius: 6px">
                <div>
                  <ul class="list-group rowposition2 mt-3" style="list-style-type: none;">
                    <li class="list-info px-2" style="color: #3B5876">
                      <img src="https://img.icons8.com/fluent/25/000000/car.png" /> Véhicule
                    </li>
                  </ul>

                  <div class="col-12 col-md-3 w-100   p-2 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF; ">

                    <div class="row px-2 ">
                      <table class="table table-hover w-100" style="border-style: hidden;">
                        <thead class="d-none">
                          <tr class="d-none">
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><b>Nom</b></td>
                            <td style="max-width:40px; word-wrap:break-word;">{{veh}}</td>
                          </tr>
                          <tr>
                            <td><b>Plaque</b></td>
                            <td style=" word-wrap:break-word;">{{plaque}}</td>
                          </tr>

                          <tr>
                            <td><b>Marque</b> </td>
                            <td style="max-width:20px; word-wrap:break-word;">{{marque}}</td>
                          </tr>



                        </tbody>
                      </table>

                    </div>
                  </div>


                </div>



              </div>
              <div class="col-12 col-md-12  p-0 " style="  border-radius: 6px">
                <div class="mr-2">
                  <ul class="list-group rowposition2" style="list-style-type: none;">
                    <li class="list-info px-2" style="color: #3B5876">
                      <img src="https://img.icons8.com/ultraviolet/25/000000/distance-warning.png" /> Distance
                    </li>
                  </ul>


                  <div class="col-12 col-md-3 w-100 my-3 pr-0 pl-2 py-0 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                    <div class="row px-2 ">

                      <table class="table table-hover w-100" style="border-style: hidden;">
                        <thead class="d-none">
                          <tr class="d-none">
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><b>Total</b></td>
                            <td style="max-width:20px; word-wrap:break-word;">
                              {{total_dist}} Km</td>
                          </tr>
                          <tr>
                            <td><b>Moyenne / trajet </b></td>
                            <td style="max-width:20px; word-wrap:break-word;">{{moy_trajet_dist}}Km</td>
                          </tr>
                          <tr>
                            <td><b>Moyenne / jour </b></td>
                            <td style="max-width:20px; word-wrap:break-word;">{{moy_jour_dist}}Km</td>
                          </tr>




                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-12 col-md-12  p-0 " style="  border-radius: 6px">
                <div class="mr-2">
                  <ul class="list-group rowposition2" style="list-style-type: none;">
                    <li class="list-info px-2" style="color: #3B5876">
                      <img src="https://img.icons8.com/office/25/000000/time.png" /> Durée
                    </li>
                  </ul>


                  <div class="col-12 col-md-3 w-100 my-3  pr-0 pl-2 py-0 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                    <div class="row px-2 ">
                      <table class="table table-hover w-100" style="border-style: hidden;">
                        <thead class="d-none">
                          <tr class="d-none">
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><b>Total</b></td>
                            <td style="max-width:40px; word-wrap:break-word;">
                              {{total_duree | formatTime}}</td>
                          </tr>
                          <tr>
                            <td><b>Moyenne / trajet </b></td>
                            <td style=" word-wrap:break-word;">{{moy_trajet_duree | formatTime}}</td>
                          </tr>
                          <tr>
                            <td><b>Moyenne / jour </b></td>
                            <td style="max-width:40px; word-wrap:break-word;">{{moy_duree_jour | formatTime}}</td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-12 p-0" style="  border-radius: 6px">
                <div>
                  <ul class="list-group rowposition2" style="list-style-type: none;">
                    <li class="list-info px-2" style="color: #3B5876">
                      <img src="https://img.icons8.com/ultraviolet/25/000000/activity-feed.png" /> Activité
                    </li>
                  </ul>


                  <div class="col-12 col-md-3 w-100 my-3  px-2 py-0 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

                    <div class="row px-2 ">
                      <table class="table table-hover w-100" style="border-style: hidden;">
                        <thead class="d-none">
                          <tr class="d-none">
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><b>Nbr trajets </b></td>
                            <td style="max-width:40px; word-wrap:break-word;">{{nbr_trajets}}</td>
                          </tr>
                          <tr>
                            <td><b>Nbr événement</b></td>
                            <td style=" word-wrap:break-word;">{{nbr_events}}</td>
                          </tr>
                          <tr>
                            <td><b>Jours actifs </b></td>
                            <td style="max-width:40px; word-wrap:break-word;">{{jrs_actives}}</td>
                          </tr>
                          <tr>
                            <td><b>Vitesse moyenne</b></td>
                            <td style="max-width:20px; word-wrap:break-word;">{{vitesse_moy}}Km/h</td>
                          </tr>




                        </tbody>
                      </table>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>




    </div> -->




    <div class="col-lg-9 col-xl-12 col-md-12 w-100 ">

      <div class="row">

        <div class="col-xl-4  w-100 ">

        </div>

      

        <div class="  pr-0 py-2 chart-sec" style="  border-radius: 6px;width: 68%;">

          <div #containerRef class="mr-2">
            <ul class="list-group mb-2">
              <li class="list-group-item active" style="color: #ffffff">
                <div class="row">
                  <div class=" col-md-8 ">
                    Historique des trajets (Sécurité)
                  </div>
                  <div class="col-md-2">

                  </div>
                  <div class="col-md-2" style="text-align: right;">
                    <mat-slide-toggle [checked]="myModel" (change)="showChart1()"></mat-slide-toggle>

                  </div>
                </div>

              </li>
            </ul>


          </div>
          <div *ngIf="chart1 == true">
            <ngx-charts-bar-vertical-stacked [view]="[containerRef.offsetWidth, 400]" [customColors]="col"
              [results]="multi1" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
              [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel" [animations]="animations" [barPadding]="10" (select)="onSelect($event)">

              <ng-template #tooltipTemplate let-model="model">
                <!-- fields are series/name/value -->

                <h3 class="pt-3 "> <img src="../../../../assets/core-img/safety_score.png" alt=""> Score SC moy.
                  {{ model.safety_score }}% </h3>

                <h3><img src="../../../../assets/core-img/eco_score.png" alt=""> Score EC moy. {{ model.eco_score
                  }}% </h3>
                <hr style="background-color: #ffffff;">
                <i class="fas fa-hourglass-start "></i> Heure de départ: {{ model.trip_start }} <br />
                <i class="fas fa-hourglass-end "></i> Heure d"arrivé: {{ model.trip_end }}<br />
                <i class="fas fa-clock "></i> Durée: {{ model.trip_duration | formatTime}} <br />
                <i class="fas fa-ruler "></i> Distance: {{ model.distance_traveled }} Km<br />
                <i class="fas fa-stopwatch-20 "></i> Temps d'inactivité: {{ model.idle_time | formatTime}}

              </ng-template>
            </ngx-charts-bar-vertical-stacked>
          </div>



        </div>
        <div class=" pr-0 py-2 chart-sec" style="  border-radius: 6px;margin-left: 2%; width: 30%;">
          <div class="mr-2">
            <ul class="list-group mb-2">
              <li class="list-group-item active" style="color: #ffffff">
                <div class="row">
                  <div class="col-10">
                    Répartition des types d'évènement


                  </div>
                 
                  <div class="col-md-2" style="text-align: right;">
                    <mat-slide-toggle [checked]="myModel" (change)="showChart2()"></mat-slide-toggle>

                  </div>
                </div>
              </li>
            </ul>
            <div [hidden]="chart2 != true">

              <apx-chart [series]="chartOptionsRadar?.series" [chart]="chartOptionsRadar?.chart"
                [xaxis]="chartOptionsRadar?.xaxis" [colors]="chartOptionsRadar?.colors"
                [dataLabels]="chartOptionsRadar?.dataLabels" [legend]="chartOptionsRadar?.legend"
                [markers]="chartOptionsRadar?.markers" [grid]="chartOptionsRadar?.grid"
                [yaxis]="chartOptionsRadar?.yaxis" [tooltip]="chartOptionsRadar?.tooltip"></apx-chart>



            </div>

          </div>


        </div>
        <div class="col-12 col-md-12 w-100  px-0 chart-sec">
          <div #containerRef class="mr-2">
            <ul class="list-group mb-2">
              <li class="list-group-item active" style="color: #ffffff">
                <div class="row">
                  <div class="col-md-8">
                    Historique des trajets (Économie)
                  </div>
                  <div class="col-md-2">

                  </div>
                  <div class="col-md-2 " style="text-align: right;">
                    <mat-slide-toggle [checked]="myModel" (change)="showChart5()"></mat-slide-toggle>

                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div *ngIf="chart5 == true" #containerRef class="w-100">
            <ngx-charts-bar-vertical-stacked [view]="[containerRef.offsetWidth, 400]" [customColors]="col2"
              [results]="multi1" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
              [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel" [animations]="animations" [barPadding]="10" (select)="onSelect($event)">


              <ng-template #tooltipTemplate let-model="model">
                <!-- fields are series/name/value -->
                <div class="tt">
                  <h3 class="pt-3 "> <img src="../../../../assets/core-img/safety_score.png" alt=""> Score SC moy.
                    {{ model.safety_score }}% </h3>

                  <h3><img src="../../../../assets/core-img/eco_score.png" alt=""> Score EC moy. {{ model.eco_score
                    }}% </h3>
                  <hr style="background-color: #ffffff;">
                  <i class="fas fa-hourglass-start "></i> Heure de départ: {{ model.trip_start }} <br />
                  <i class="fas fa-hourglass-end "></i> Heure d"arrivé: {{ model.trip_end }}<br />
                  <i class="fas fa-clock "></i> Durée: {{ model.trip_duration | formatTime}} <br />
                  <i class="fas fa-ruler "></i> Distance: {{ model.distance_traveled }} Km<br />
                  <i class="fas fa-stopwatch-20 "></i> Temps d'inactivité: {{ model.idle_time | formatTime}}



                </div>
              </ng-template>


            </ngx-charts-bar-vertical-stacked>
          </div>
        </div>
        <div class="col-12 col-md-12 w-100 px-0 chart-sec">
          <div class="mr-2">
            <ul class="list-group mb-2">
              <li class="list-group-item active" style="color: #ffffff">
                <div class="row">
                  <div class="col-md-8">
                    Évolution du score de sécurité
                  </div>
                  <div class="col-md-2">

                  </div>


                  <div class="col-md-2" style="text-align: right;">
                    <mat-slide-toggle [checked]="myModel" (change)="showChart3()"></mat-slide-toggle>

                  </div>
                </div>
              </li>
            </ul>
            <div *ngIf="chart3 == true">
              <apx-chart [annotations]="chartOptions3?.annotations" [series]="chartOptions3?.series"
                [chart]="chartOptions3?.chart" [xaxis]="chartOptions3?.xaxis" [stroke]="chartOptions3?.stroke"
                [colors]="chartOptions3?.colors" [dataLabels]="chartOptions3?.dataLabels"
                [legend]="chartOptions3?.legend" [markers]="chartOptions3?.markers" [grid]="chartOptions3?.grid"
                [yaxis]="chartOptions3?.yaxis" [tooltip]="chartOptions3?.tooltip"></apx-chart>
            </div>

          </div>

        </div>
        <div class="col-12 col-md-12 w-100  px-0 chart-sec ">
          <div class="mr-2">
            <ul class="list-group mb-2">
              <li class="list-group-item active" style="color: #ffffff">
                <div class="row">
                  <div class="col-md-8">
                    Évolution du score d'économie
                  </div>
                  <div class="col-md-2">

                  </div>
                  <div class="col-md-2" style="text-align: right;">
                    <mat-slide-toggle [checked]="myModel" (change)="showChart4()"></mat-slide-toggle>

                  </div>
                </div>
              </li>
            </ul>
            <div *ngIf="chart4== true">
              <apx-chart [annotations]="chartOptions5?.annotations" [series]="chartOptions5?.series"
                [chart]="chartOptions5?.chart" [xaxis]="chartOptions5?.xaxis" [stroke]="chartOptions5?.stroke"
                [colors]="chartOptions5?.colors" [dataLabels]="chartOptions5?.dataLabels"
                [legend]="chartOptions5?.legend" [markers]="chartOptions5?.markers" [grid]="chartOptions5?.grid"
                [yaxis]="chartOptions5?.yaxis" [tooltip]="chartOptions5?.tooltip"></apx-chart>
            </div>

          </div>
        </div>

        

      </div>





    </div>
  </div>

</div>
<!-- <button (click)="onExportClick()">click to export</button>

<button (click)="getveh_byId()"></button> -->
